import clsx from "clsx";

/** A person's photo, or their first letter when they have none. */
export function Avatar({ name, fileId, className }: { name: string; fileId?: string | null; className?: string }) {
  return fileId
    ? <img src={`/api/v1/core/files/${fileId}/content?inline=true`} alt="" className={clsx("shrink-0 rounded-full object-cover", className)} />
    : <span aria-hidden className={clsx("flex shrink-0 items-center justify-center rounded-full bg-ink font-semibold text-white", className)}>{name.trim().charAt(0)}</span>;
}
